import { districtAPIIntrface } from '@interface';
import axios from "axios";
import { districtAPIobj } from '@mockData';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
    baseURL: API_BASE_URL,
});

export const districtPropertylist = async ({ module, id }: districtAPIIntrface) => {
    try {
        return await api.get(`/${districtAPIobj[module]}/${id}/properties/?format=json&summary=true&summary-type=short-annotated&annotation__start=full&unitsres__gte=1`);

    } catch (error) {
        throw error;
    }
};

export const districtPropertyCustomSearch = async ({ module, id, params }: districtAPIIntrface) => {
    try {
        const districtRoute = module === 'borough' || module === 'city' ? '' : `/${districtAPIobj[module]}/${id}`;
        return await api.get(`${districtRoute}/properties/`, {
            params: {
                format: "json",
                summary: "true",
                "summary-type": "custom-search",
                ...params, // Spread the params object here
            },
        });
    } catch (error) {
        throw error;
    }
};
